import { render, staticRenderFns } from "./Dispensers.vue?vue&type=template&id=4e02da65&scoped=true&"
import script from "./Dispensers.vue?vue&type=script&lang=js&"
export * from "./Dispensers.vue?vue&type=script&lang=js&"
import style0 from "./Dispensers.vue?vue&type=style&index=0&id=4e02da65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e02da65",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDataTable,VIcon,VRow})
